
import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable()
export class CollectionService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  GetAllProductsBySearchKeywordsWords( SearchKeywords:string ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  
  return this.http.get(""+this.apiUrl+"/WebsiteHome/GetAllProductsBySearchKeywordsWords?SearchKeyword="+SearchKeywords,httpOptions);
  
  }


  getAllMENSCOLLECTIONData() {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/WebsiteHome/GetAllMENSCOLLECTION",httpOptions);
  }

  getAllMENSCOLLECTION_NAMEData( ItemNames:string ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/WebsiteHome/GetAllMENSCOLLECTION_NAME?ItemName="+ItemNames,httpOptions);
  }




  getAllOTHERSCOLLECTIONData() {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/WebsiteHome/GetAllOTHERSCOLLECTION",httpOptions);
  }

  getAllOTHERSCOLLECTION_NAMEData( ItemName:string ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/WebsiteHome/GetAllOTHERSCOLLECTION_NAME?ItemName="+ItemName,httpOptions);
  }





  getAllUNISEXCOLLECTIONData() {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/WebsiteHome/GetAllUNISEXCOLLECTION",httpOptions);
  }

  getAllUNISEXCOLLECTION_NAMEData( ItemName:string ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/WebsiteHome/GetAllUNISEXCOLLECTION_NAME?ItemName="+ItemName,httpOptions);
  }



  getAllWOMENSCOLLECTIONData() {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/WebsiteHome/GetAllWOMENSCOLLECTION",httpOptions);
  }


  getAllWOMENSCOLLECTION_NAMEData( ItemName:string ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/WebsiteHome/GetAllWOMENSCOLLECTION_NAME?ItemName="+ItemName,httpOptions);
  }


  
  
  getAllAffiliatedLinksData( brandname:string, sku:string , stat:number  ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  
  
 return this.http.get(""+this.apiUrl+"/ItemBasic7_Affiliate/GetAllAffiliatedLinksByBrandNameSKU?BrandName="+brandname+"&SKU="+sku+"&Status="+stat,httpOptions);
 
 // return this.http.get("http://localhost:57597/api/ItemBasic7_Affiliate/GetAllAffiliatedLinksByBrandNameSKU?BrandName="+brandname+"&SKU="+sku+"&Status="+stat,httpOptions);
 

  }

  
  uploadData(data) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };


     return this.http.post<any>(""+this.apiUrl+"/ApplicationEntriesDetails/UploadFiling", data, {
      reportProgress: true,
     observe: 'events'
  });

  // return this.http.post<any>("http://localhost:57597/api/ApplicationEntriesDetails/UploadFiling", data, {
  //   reportProgress: true,
  //   observe: 'events'
  // });


  }



  getAllItemBasic2VariationByItemProductTypeMainId( id:number ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  
  return this.http.get(""+this.apiUrl+"/ItemBasic2_Variation/GetAllItemBasic2VariationByItemProductTypeMainId?ItemProductTypeMainId="+id,httpOptions);

  
  }


  getFillSKUWithoutID( SearchKeywords:string) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  
  return this.http.get(""+this.apiUrl+"/WebsiteHome/GetAllProductsBySearchKeywordsWords?SearchKeyword="+SearchKeywords,httpOptions);
  
  }


}
